import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import ProjectImage from '../../components/ProjectImage';
import styles from './styles.module.scss';

let xDown = null;
let yDown = null;

class Project extends Component {
  state = {
    currentImage: 0,
    index: null,
    nextSlug: null,
    prevSlug: null,
  };

  componentWillMount() {
    const { data } = this.props;
    const projects = data.allContentfulProject.edges.map(({ node }) => node);
    const thisSlug = data.contentfulProject.slug;
    const thisIndex = projects.findIndex(({ slug }) => thisSlug === slug);

    const imageFeed = projects.filter((project) => !!project.images && project.images.length > 0);
    const feedIndex = imageFeed.findIndex(({ slug }) => thisSlug === slug);
    const lastProject = imageFeed.length - 1;

    this.setState({
      index: thisIndex + 1,
      nextSlug:
        feedIndex !== lastProject
          ? `${imageFeed[feedIndex + 1].slug}/images/`
          : `${imageFeed[0].slug}/images/`,
      prevSlug:
        feedIndex !== 0
          ? `${imageFeed[feedIndex - 1].slug}/images/`
          : `${imageFeed[lastProject].slug}/images/`,
    });
  }

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyPress);

    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyPress);
    document.removeEventListener('touchstart', this.handleTouchStart, false);
    document.removeEventListener('touchmove', this.handleTouchMove, false);
  }

  onKeyPress = e => {
    const key = e.keyCode ? e.keyCode : e.which;
    if (key === 39) this.goToNext();
    if (key === 37) this.goToPrev();
  };

  goToNext = state => {
    const { data } = this.props;
    const { currentImage, nextSlug } = this.state;
    const { images } = data.contentfulProject;

    if (images && currentImage < images.length - 1) {
      this.setState({
        currentImage: currentImage + 1,
      });
    } else {
      navigateTo({
        pathname: `/${nextSlug}`,
        state,
      });
    }
  };

  goToPrev = () => {
    const { currentImage, prevSlug } = this.state;

    if (currentImage > 0) {
      this.setState({
        currentImage: currentImage - 1,
      });
    } else {
      navigateTo({
        pathname: `/${prevSlug}`,
      });
    }
  };

  handleClick = () => {
    this.goToNext();
  };

  handleTouchStart = (evt) => {
    const firstTouch = evt.touches[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  handleTouchMove = (evt) => {
    evt.preventDefault();
    if (!xDown || !yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = xDown - xUp;
    const yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        this.goToNext();
      } else {
        this.goToPrev();
      }
    }
    xDown = null;
    yDown = null;
  }

  render() {
    const { data } = this.props;
    const { currentImage, index } = this.state;
    const { buyLink, client, images, slug, title } = data.contentfulProject;

    const imageToShow = images && images[currentImage];

    return (
      <div key={slug}>
        <Header
          anchor={slug}
          background
          buy={buyLink}
          client={client}
          id={index}
          slug={`/${slug}`}
          title={title}
          total={data.allContentfulProject.edges.length}
        />
        <div
          className={styles.wrapper}
          onClick={this.handleClick}
          style={{
            cursor: 'e-resize',
            width: '100vw',
          }}
        >
          {imageToShow && (
            <ProjectImage src={imageToShow.asset.file.url} />
          )}
        </div>
      </div>
    );
  }
}

export default Project;

Project.propTypes = {
  data: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ProjectImages/index.jsx